export const contactsData = {
  email: " srinivasan.webdev@gmail.com ",
  phone: "+91 9629131792",
  address: "Coimbatore, TamilNadu, India ",
  github: "https://github.com/SriS0",
  linkedIn: "https://www.linkedin.com/in/sriweb/",
  devUsername: "said7388"
};